import { SHOPIFY_PRODUCT_CORE_QUESTION_TEXT, imageConceptDiagnosticQuestions } from './product-research-questions.js';
/** Image purpose changes the diagnostic ask, not the product constructs or physical image treatment. */
export function imageConcept(role, label, description, order) {
    return {
        semanticRole: role,
        variantType: role,
        eligibleForStudy: false,
        uiBadge: { label, tone: 'neutral' },
        group: { key: role, title: label, description, order },
        classificationReason: description,
        coreQuestions: {
            version: 1,
            questionSetId: `${role}-product-core-questions-v1`,
            ...SHOPIFY_PRODUCT_CORE_QUESTION_TEXT,
        },
        diagnosticQuestions: imageConceptDiagnosticQuestions(role),
        contracts: {
            elementType: 'image_creative',
            stimulusContract: 'visual_concept',
            treatmentContract: 'image_variant',
        },
    };
}
//# sourceMappingURL=product-research-image-concepts.js.map